import { useMemo } from 'react';

import { CustomerCancelReason, DeviceOS } from 'enums';
import { userDeviceUtils } from 'utils';

import { DEEPLINK_URL_SEPARATOR } from './use-deeplink.hook';
import { useOrderContext } from './use-order-context.hook';

export const useCancelSurveyReasons = () => {
  const { deeplinks, shouldShowQrCode } = useOrderContext();

  const deviceOS = useMemo(() => userDeviceUtils.getDeviceOS(), []);

  const reasons = useMemo(() => {
    const result = [
      CustomerCancelReason.NoBank,
      CustomerCancelReason.ChangedMind,
      CustomerCancelReason.BankPaymentRejected,
    ];

    const hasDeeplinkButtons =
      deviceOS !== DeviceOS.Desktop && deeplinks.some((d) => d.url);
    const hasDeeplinkQr =
      deviceOS === DeviceOS.Desktop &&
      deeplinks.some((d) => d.url && !DEEPLINK_URL_SEPARATOR.test(d.url));

    if (hasDeeplinkButtons) {
      result.push(CustomerCancelReason.PaymentButtonNotWorking);
    }

    if (shouldShowQrCode) {
      result.push(CustomerCancelReason.QrNotWorking);
    }

    if (shouldShowQrCode || hasDeeplinkQr) {
      result.push(CustomerCancelReason.RequisitesNotFilled);
    }

    return result;
  }, [deeplinks, deviceOS, shouldShowQrCode]);

  return { reasons };
};
